<template>
  <div
    :class="[version, box]"
    class="tabs is-fullwidth"
  >
    <ul>
      <li
        v-for="(item, index) in arr"
        :key="`tab-${index}`"
        :class="{
          'is-active': current === index,
          disabled: isVersion2 && completeEffect && !isStepCompleted(index),
          'is-done': isVersion2 && completeEffect && index < current,
        }"
        class="tab"
        @click="tab(index)"
      >
        <a :class="{ 'pre-conter': hasPreCounter }">
          <span>
            {{ item[arrProp] }}

            <template v-if="item.info">
              <span class="counter ml-2">{{ item.info }}</span>
            </template>

            <template v-if="item.tag">
              <span class="chip">{{ item.tag }}</span>
            </template>
          </span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'BaseTab',
  props: {
    value: {
      type: Number,
      default: 0,
      required: false,
    },
    arr: {
      type: Array,
      default: () => [
        { title: 'Tab' },
      ],
      required: true,
    },
    arrProp: {
      type: String,
      default: 'title',
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    version: {
      type: String,
      default: 'v1',
      required: false,
    },
    box: {
      type: String,
      default: 'is-boxed',
      required: false,
    },
    hasPreCounter: {
      type: Boolean,
      default: true,
      required: false,
    },
    completedSteps: {
      type: Array,
      default: () => [],
      required: false,
    },
    completeEffect: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data: () => ({
    current: 0,
  }),
  computed: {
    ...mapGetters({
      isMobile: 'app/isMobile',
    }),
    isStepCompleted() {
      return (index) => this.completedSteps.includes(index);
    },
    isVersion2() {
      return this.version === 'v2';
    },
  },
  watch: {
    value: {
      handler(val) {
        this.current = val;
      },
      immediate: true,
    },
    current(value) {
      this.emit(value);
    },
  },
  methods: {
    tab(index) {
      if (this.disabled) return;

      this.current = index;
      this.emit(this.current);
    },
    emit(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.recuo:before {
  margin-right: 1rem;
}
@mixin counter($bg-color, $color) {
  display: flex;
  width: 26px;
  height: 20px;
  background-color: $bg-color;
  border-radius: 10px;
  padding: 2px 10px;

  align-items: center;
  justify-content: center;

  font: {
    family: Inter;
    size: 12px;
    weight: 500;
  }
  line-height: 16px;
  color: $color;
}

.tabs {
  counter-reset: index;

  ul {
    margin-left: 0;
  }

  .tab {
    &.disabled {
      pointer-events: none;
    }
  }

  &.v2 {
    white-space: wrap;

    ul {
      border-bottom-color: map.get($stone-types, '100');
    }

    li {
      &.is-active {
        a {
          border-bottom: 4px solid $prata-green-500 !important;

          font: {
            weight: 700;
          }
          color: $prata-green-600;

          &::before {
            background-color: $prata-green-100 !important;
            color: $prata-green-700 !important;
          }
        }
      }

      &.is-done {
        a.pre-conter {

          &::before {
            content: '\f00c';

            background-color: $prata-green-600;
            color: white;

            font-family: 'Font Awesome 5 Free', sans-serif;
            font-weight: 900;
          }
        }
      }
    }

    li {
      flex: 1 1 0;
    }

    a {
      display: flex;
      height: 60px;
      border: none;
      border-bottom: 1px solid map.get($stone-types, '100') !important;

      align-items: center;

      font: {
        family: Inter;
        size: 14px;
        weight: 500;
      }
      line-height: 20px;
      color: $gray-400;

      > span {
        position: relative;
        display: flex;
      }
    }

    .tab {
      a {
        text-align: center;
        &.pre-conter {
          padding: 0;
          &::before {
            @include counter(#F3F4F6, #6B7280);

            margin-right: 0 auto;
            counter-increment: index;
            content: counter(index);
          }
        }
      }
    }

    .chip {
      position: absolute;
      top: -75%;
      right: -35%;

      border-radius: 10px;
      padding: 2px 10px;

      font: {
        family: Inter;
        size: 10px;
        weight: 500;
      }
      text-align: center;

      background-color: #DBEAFE;
      color: #1E40AF;
    }

    .counter {
      @include counter($orange-100, $orange-600);
    }
  }
}
@media only screen and (min-width: 1024px) {
  .tab {
    a {
      &.pre-conter {
        &::before {
          margin-right: 8px;
          margin-left: 8px;
        }
      }
    }
  }
}

</style>
